"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CubeStore = void 0;
var mobx_1 = require("mobx");
var common_1 = require("services/page/common");
var CubeStore = (function () {
    function CubeStore(props) {
        var _this = this;
        this.formatData = function (data) {
            _this.TCubeModule = data;
        };
        this.formatData(props);
    }
    Object.defineProperty(CubeStore.prototype, "Cube", {
        get: function () {
            return __spreadArrays((this.TCubeModule && this.TCubeModule.module && this.TCubeModule.module.elements));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CubeStore.prototype, "interaction", {
        get: function () {
            return ((this.TCubeModule && this.TCubeModule.layout && this.TCubeModule.layout.interaction) ||
                common_1.ModuleInteraction.Zoom);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CubeStore.prototype, "TCubeModule", void 0);
    __decorate([
        mobx_1.computed
    ], CubeStore.prototype, "Cube", null);
    __decorate([
        mobx_1.computed
    ], CubeStore.prototype, "interaction", null);
    __decorate([
        mobx_1.action
    ], CubeStore.prototype, "formatData", void 0);
    return CubeStore;
}());
exports.CubeStore = CubeStore;
